export default __webpack_public_path__ + "static/AboutBrian-1024x643-b273b6b2412d97de6620e7cfe6dabcaf.jpg";